export default __webpack_public_path__ + "static/media/ic_bsc_96.369f1d28.svg";